/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'monitor': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M20 2.4A2.6 2.6 0 0122.6 5v10a2.6 2.6 0 01-2.6 2.6h-7.4v2.8H16a.6.6 0 110 1.2H8a.6.6 0 010-1.2h3.4v-2.8H4A2.6 2.6 0 011.4 15V5A2.6 2.6 0 014 2.4h16zM4 3.6c-.773 0-1.4.627-1.4 1.4v10c0 .773.627 1.4 1.4 1.4h16a1.4 1.4 0 001.4-1.4V5c0-.773-.627-1.4-1.4-1.4H4z" _fill="#0077C8"/>'
  }
})
